import { useEffect, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { exchangeSession } from "@/lib/api";
import { useAuth, getDeviceId, saveDeviceId } from "@/context/AuthContext";

export default function AuthCallback() {
  const location = useLocation();
  const navigate = useNavigate();
  const { setUser } = useAuth();
  const processed = useRef(false);

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;
    const sessionId = new URLSearchParams(location.hash.slice(1)).get("session_id");
    exchangeSession(sessionId, getDeviceId())
      .then(({ device_id, ...user }) => {
        saveDeviceId(device_id);
        setUser(user);
        navigate("/", { replace: true });
      })
      .catch((e) => {
        toast.error(e?.response?.data?.detail || "Sign-in failed. Please try again.", { duration: 10000 });
        navigate("/", { replace: true });
      });
  }, [location.hash, navigate, setUser]);

  return <div className="min-h-screen bg-[#09090B]" data-testid="auth-callback" />;
}
